<h2 mat-dialog-title>{{'inspectionReportEditTextValidationDialog.Confirmation' | translate}}</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <p>{{'inspectionReportEditTextValidationDialog.MsgFillInReqFields' | translate}}</p>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close] ="true"  color="primary">{{'inspectionReportEditTextValidationDialog.OK' | translate}}</button>
  </mat-dialog-actions>
</div>